import { render } from "./RightSideBar.vue?vue&type=template&id=5c41e9f9"
import script from "./RightSideBar.vue?vue&type=script&lang=js"
export * from "./RightSideBar.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__